import React from 'react';
import classNames from 'classnames';

import s from './topSectionContactsPlaceholder.scss';

/**
 * Top section skeleton
 * @constructor
 */
export const TopSectionContactsPlaceholder = () => {
    return (
        <>
            <div className={s.contactsReturn} />
            <div className={s.contactsBannerWrapper}>
                <div className={s.contactsBannerPlaceHolder} />
                <div className={s.contactsTextLine} />
                <div className={classNames(s.contactsTextLine, s.contactsSecondLine)} />
                <div className={s.contactsButton} />
            </div>
            <div className={s.contactsTitle}>
                <div className={classNames(s.contactsTextLine, s.contactsTitleText)} />
                <div
                    className={classNames(
                        s.contactsTextLine,
                        s.contactsTitleText,
                        s.contactsSecondLine,
                    )}
                />
            </div>
            <div className={s.contactsFindField} />
            <ul className={s.contactsBrandsList}>
                <li className={s.contactsBrandsListItem} />
                <li className={s.contactsBrandsListItem} />
                <li className={s.contactsBrandsListItem} />
                <li className={s.contactsBrandsListItem} />
            </ul>
        </>
    );
};
